import { Button, FormControl, Grid } from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import DateLocalizationProvider from "../../../../components/element/DateLocalizationProvider";
import { DATE_FORMAT } from "../../../../utils/constants";
import "../css/PassengerCountDisputeFilter.css";
import BadgesFilterSelect from "../../../../components/element/BadgesFilterSelect";

const PassengerCountDisputeFilter = ({
  onClickClear,
  onClickApply,
  currentFlightNumber = "",
  currentSelectedDate = null,
  currentSelectedBadges = [],
  isAAUser = false,
}) => {
  const [flightNumber, setFlightNumber] = useState(currentFlightNumber);
  const [selectedDate, setSelectedDate] = useState(() => {
    return currentSelectedDate ? dayjs(currentSelectedDate) : null;
  });
  const [selectedBadges, setSelectedBadges] = useState(currentSelectedBadges || []);

  // Update local state when props change
  useEffect(() => {
    setFlightNumber(currentFlightNumber);
  }, [currentFlightNumber]);

  useEffect(() => {
    // Ensure we're working with a dayjs object
    if (currentSelectedDate) {
      setSelectedDate(dayjs(currentSelectedDate));
    } else {
      setSelectedDate(null);
    }
  }, [currentSelectedDate]);

  useEffect(() => {
    setSelectedBadges(currentSelectedBadges || []);
  }, [currentSelectedBadges]);
  const setDefaultValue = () => {
    setFlightNumber("");
    setSelectedDate(null);
    setSelectedBadges([]);
  };

  const handleClearFilter = () => {
    setDefaultValue();
    onClickClear();
  };
  const handleFlightNumberChange = (event) => {
    setFlightNumber(event.target.value);
  };

  const handleDateChange = (newValue) => {
    setSelectedDate(newValue);
  };

  return (
    <div className="passenger-dispute-filter-container">
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <FormControl variant="outlined">
                <div className="passenger-dispute-filter-header">
                  Search by Flight Number
                </div>
                <input
                  name="passenger-dispute-filter-invoice-number"
                  value={flightNumber}
                  onChange={handleFlightNumberChange}
                  maxLength={15}
                />
              </FormControl>
            </Grid>

            <DateLocalizationProvider>
              <Grid item>
                <FormControl variant="outlined">
                  <div className="passenger-dispute-filter-header">
                    Departure Date
                  </div>
                  <MobileDatePicker
                    id="passenger-dispute-filter-departure-datepicker"
                    className="invoicing-IATA-filter-datepicker"
                    format={DATE_FORMAT}
                    maxDate={dayjs()}
                    value={selectedDate}
                    onChange={handleDateChange}
                  />
                </FormControl>
              </Grid>
            </DateLocalizationProvider>

            {isAAUser && (
              <Grid item>
                <FormControl variant="outlined">
                  <div className="passenger-dispute-filter-header">Badges</div>
                  <BadgesFilterSelect
                    selectedBadges={selectedBadges}
                    onChange={setSelectedBadges}
                    selectClassName="flight-roster-filter-select-container flight-roster-filter-select-badges"
                  />
                </FormControl>
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid item>
          <div className="passenger-dispute-filter-button-container">
            <Button className="clear" onClick={handleClearFilter}>
              Clear
            </Button>
            <Button
              variant="contained"
              color="secondaryButton"
              disabled={
                !flightNumber && !selectedDate && selectedBadges.length === 0
              }
              onClick={() => onClickApply(flightNumber, selectedDate, selectedBadges)}
            >
              Apply
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default PassengerCountDisputeFilter;
